<template>
  <footer class="footer">

    <!-- PASEK PŁATNOŚCI -->
    <div class="payments-bar">
      <div class="payments-inner">
        <span class="payments-label">{{ t.payments_bar?.title }}:</span>
        <div class="payments-icons">
          <span class="pay-chip">
            <svg width="18" height="18" viewBox="0 0 40 24" fill="none"><rect width="40" height="24" rx="4" fill="#0066FF"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="8" font-weight="bold">BLIK</text></svg>
            BLIK
          </span>
          <span class="pay-chip">
            <svg width="28" height="18" viewBox="0 0 50 30" fill="none"><rect width="50" height="30" rx="4" fill="#1A1F71"/><text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="10" font-weight="bold" font-style="italic">VISA</text></svg>
          </span>
          <span class="pay-chip">
            <svg width="28" height="18" viewBox="0 0 50 30" fill="none"><rect width="50" height="30" rx="4" fill="#fff" stroke="#e5e7eb"/><circle cx="20" cy="15" r="9" fill="#EB001B" opacity=".9"/><circle cx="30" cy="15" r="9" fill="#F79E1B" opacity=".9"/></svg>
            MC
          </span>
          <span class="pay-chip">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#4285F4"/><path d="M12 2C9.24 2 6.76 3.24 5.08 5.23L12 12V2z" fill="#EA4335"/><path d="M2 12c0 2.76 1.24 5.24 3.23 6.92L12 12H2z" fill="#FBBC04"/><path d="M12 22c2.76 0 5.24-1.24 6.92-3.23L12 12v10z" fill="#34A853"/></svg>
            G Pay
          </span>
          <span class="pay-chip">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            Apple Pay
          </span>
          <span class="pay-chip pay-p24">P24</span>
          <span class="pay-chip pay-klarna">Klarna</span>
          <span class="pay-chip pay-paypal">PayPal</span>
          <span class="pay-chip pay-stripe">Stripe</span>
        </div>
      </div>
    </div>

    <div class="footer-contact">
      <div class="footer-contact-left">
        <h2 v-html="t.footer?.contact?.title"></h2>
        <p>{{ t.footer?.contact?.subtitle }}</p>
        <p>{{ t.footer?.contact?.call }} - +48 720 992 745</p>
        <p>{{ t.footer?.contact?.write }} - <a href="mailto:biuro@birdea.pl">biuro@birdea.pl</a></p>
      </div>
      <form class="footer-contact-form" @submit.prevent="sendContact">
        <input v-model="form.email" type="email" :placeholder="t.footer?.form?.email_placeholder" required />
        <input v-model="form.phone" type="text" :placeholder="t.footer?.form?.phone_placeholder" />
        <textarea v-model="form.message" :placeholder="t.footer?.form?.message_placeholder" rows="4" required></textarea>
        <button type="submit" :disabled="loading">{{ t.footer?.form?.button }}</button>
        <p v-if="success" style="color:#22c55e;margin-top:8px">{{ t.footer?.form?.success_message }}</p>
      </form>
    </div>

    <div class="footer-links">
      <div class="footer-column contact-info">
        <h4>{{ t.footer?.info?.title }}</h4>
        <p><a href="tel:+48720992745">+48 720 992 745</a></p>
        <p><a href="mailto:biuro@birdea.pl">biuro@birdea.pl</a></p>
        <p>BIRDSOFT sp. z o.o.</p>
        <p>PL6222856070</p>
        <p>ul. Kaliska 35A/210<br>Ostrów Wielkopolski</p>
        <p>POLSKA</p>
      </div>
      <div class="footer-column">
        <h4>{{ t.footer?.about?.title }}</h4>
        <router-link to="/kontakt">{{ t.footer?.about?.kontakt }}</router-link>
        <router-link to="/uslugi">{{ t.footer?.about?.uslugi }}</router-link>
        <router-link to="/wysylka">{{ t.footer?.about?.wysylka }}</router-link>
        <router-link to="/zwrot">{{ t.footer?.about?.zwrot }}</router-link>
        <router-link to="/regulamin">{{ t.footer?.about?.regulamin }}</router-link>
        <router-link to="/polityka">{{ t.footer?.about?.polityka }}</router-link>
      </div>
      <div class="footer-column social-media">
        <h4>{{ t.footer?.social?.title }}</h4>
        <div class="icons">
          <a href="https://www.facebook.com/birdeapl/" target="_blank" rel="noopener">Facebook</a>
          <a href="https://www.instagram.com/birdeapl/" target="_blank" rel="noopener">Instagram</a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2025 Birdea / BIRDSOFT sp. z o.o. | +48 720 992 745 | {{ t.footer?.copyright }}</span>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'
import { translations } from '@/locales/lang'

const t = translations
const form = ref({ email: '', phone: '', message: '' })
const loading = ref(false)
const success = ref(false)

async function sendContact() {
  loading.value = true
  success.value = false
  try {
    const csrfToken = document.cookie.split('; ').find(r => r.startsWith('csrftoken='))?.split('=')[1] || ''
    const res = await fetch('/api/v1/contact-request/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
      body: JSON.stringify(form.value)
    })
    if (!res.ok) throw new Error()
    form.value = { email: '', phone: '', message: '' }
    success.value = true
  } catch(e) { console.error(e) }
  finally { loading.value = false }
}
</script>

<style scoped>
/* PAYMENTS BAR */
.payments-bar {
  background: #f9f9f9;
  border-bottom: 1px solid #efefef;
  padding: 14px 24px;
}
.payments-inner {
  max-width: 1200px; margin: 0 auto;
  display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
}
.payments-label {
  font-size: .8rem; font-weight: 700; color: #666;
  white-space: nowrap;
}
.payments-icons {
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.pay-chip {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 5px 10px; border-radius: 6px;
  border: 1px solid #e5e7eb; background: #fff;
  font-size: .78rem; font-weight: 700; color: #333;
  white-space: nowrap;
}
.pay-p24    { background: #c8102e; color: #fff; border-color: #c8102e; }
.pay-klarna { background: #ffb3c7; color: #111; border-color: #ffb3c7; }
.pay-paypal { background: #003087; color: #fff; border-color: #003087; }
.pay-stripe { background: #635bff; color: #fff; border-color: #635bff; }
</style>
